import { ResumeUploadAction } from './constants';

const initialState = {
  loading: false,
  isUploading: false,
  showResumeUpload: true,
  resume: '',
  parsedInfo: null,
  showModal: false,
  resumePreview: false,
  linkedin_url: '',
  linkedinImported: false
};

function ResumeUploadReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };

  switch (type) {
    case ResumeUploadAction.LOADING: {
      return { ...state, loading: payload };
    }
    case ResumeUploadAction.FETCH_RESUME_PARSED_DATA_SUCCESS: {
      return { ...state, parsedInfo: payload };
    }
    case ResumeUploadAction.FETCH_RESUME_PARSED_DATA_FAIL: {
      return { ...state, loading: payload };
    }
    case ResumeUploadAction.FETCH_RESUME_INFO_SUCCESS: {
      return { ...state, ...payload };
    }
    case ResumeUploadAction.FETCH_RESUME_INFO_FAIL: {
      return { ...state, loading: payload };
    }
    case ResumeUploadAction.UPLOAD_RESUME_SUCCESS: {
      return { ...state, ...payload };
    }
    case ResumeUploadAction.UPLOAD_RESUME_FAIL: {
      return { ...state, loading: payload };
    }
    case ResumeUploadAction.ISRESUME_UPLOADING: {
      return { ...state, isUploading: payload };
    }
    case ResumeUploadAction.SHOW_RESUME_UPLOAD: {
      return { ...state, ...payload };
    }
    case ResumeUploadAction.RESUME_MODAL_SKIP: {
      return { ...state, showModal: payload };
    }
    case ResumeUploadAction.RESET_DATA: {
      return { state: initialState };
    }
    case ResumeUploadAction.SYNC_LINKEDIN_FAIL: {
      return { ...state, loading: payload };
    }
    case ResumeUploadAction.SYNC_LINKEDIN_SUCCESS: {
      return { ...state, linkedinImported: true, ...payload };
    }
    case ResumeUploadAction.LINKEDIN_SYNCED_DATA_SUCCESS: {
      return { ...state, parsedInfo: payload };
    }
    case ResumeUploadAction.URL_ERROR: {
      return { ...state, urlError: payload };
    }
    case ResumeUploadAction.SET_LINKEDIN_URL: {
      return { ...state, ...payload }
    }
    default:
      return state;
  }
}

export default ResumeUploadReducer;
